import { Suspense } from "react";
import { Outlet } from "react-router";
import { Box, Container } from "@mui/material";
import GlobalBanner from "components/common/GlobalBanner";
import { LegalFooter } from "components/common/LegalFooter";
import Logo from "components/common/Logo";
import Card from "components/shared/Card";
import Loading from "components/shared/Loading";
import styles from "./EntryLayout.styles";

const EntryLayout = () => (
  <>
    <GlobalBanner />
    <Container sx={styles.container}>
      <Box sx={styles.cardContainer}>
        <Suspense fallback={<Loading />}>
          <Card sx={styles.layoutContainer}>
            <Logo role="banner" />
            <Outlet />
          </Card>
        </Suspense>
      </Box>
      <LegalFooter />
    </Container>
  </>
);

export default EntryLayout;
